export default __webpack_public_path__ + "03b9c5e1f4.woff";